module.exports = __webpack_public_path__ + "static/media/project-manager-img.e997baab.svg";